module.exports = __webpack_public_path__ + "img/parts.fb24beaa.png";